import { render, staticRenderFns } from "./AfterMain.vue?vue&type=template&id=25ebccc3&lang=true&"
import script from "./AfterMain.vue?vue&type=script&lang=js&"
export * from "./AfterMain.vue?vue&type=script&lang=js&"
import style0 from "./AfterMain.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports